// Based on:
// - http://stackoverflow.com/questions/22891827/how-do-i-hand-draw-on-canvas-with-javascript
// - https://github.com/u-kudox/BitmapData_for_EaselJS

import AssetManager from "lib/src/AssetManager";
import Utils from "lib/src/utils";
import SoundManager from "lib/src/SoundManager";
import * as $ from "jquery";

require('src/BitmapData-custom.js');

var BG_IMG = Utils.getParameterByName("bg") || '3_ChloesToverkast_Kleurplaat_Tara_Edited_J.png';

// this follows the ordering in the 'tools' html container
var TOOL_BRUSH = 0;
var TOOL_PENCIL = 1;
var TOOL_BUCKET = 2;
var MAX_UNDO = 10;  // for flood fill, we're copying the entire bitmap, so be careful with memory usage

export default class Kleurplaat {

    private _selectedColor;
    private _canvas;
    private _stage;
    private _originalImage;
    private _currentBitmapData;
    private _undoData = [];
    private _haveUndoForCurrentOperation = false;
    private _bitmap;
    private _selectedTool;
    private _drawingCanvas;
    private _oldPt;
    private _oldMidPt;
    private _mouseMoveListener;

    public start(canvas) {
        // resize canvas to fullscreen
        canvas.width = $('html').width();
        canvas.height = $('html').height();

        var img = new Image();
        img.onload = () => this.init(canvas, img);
        img.src = AssetManager.getForChar(BG_IMG);
    }

    public init(canvas, img) {
        this._canvas = canvas;
        this._stage = new createjs.Stage(this._canvas);
        if (createjs.Touch.isSupported()) {
            createjs.Touch.enable(this._stage, true);
        }
        this._stage.addEventListener("stagemousedown", (evt) => {
            this.handleMouseDown(evt);
        });
        this._stage.addEventListener("stagemouseup", (evt) => {
            this.handleMouseUp(evt);
        });

        var stageW = this._canvas.width;
        var stageH = this._canvas.height;

        // resize and center bitmap
        // (create a 200px fake border around the image, so we keep 100px on each side)
        var bitmapToCanvasScale = 1 / Math.max(img.width / (stageW - 200), img.height / (stageH - 100));
        // don't scale up
        bitmapToCanvasScale = Math.min(1, bitmapToCanvasScale);
        var pos = {
            x: (stageW / 2) - ((img.width) * bitmapToCanvasScale) / 2,
            y: (stageH / 2) - ((img.height) * bitmapToCanvasScale) / 2
        };

        try {
            var createjsUnsafe = createjs as any;
            this._originalImage = new createjsUnsafe.BitmapData(null, stageW, stageH);
            var matrix = new createjs.Matrix2D();
            matrix.appendTransform(pos.x, pos.y, bitmapToCanvasScale, bitmapToCanvasScale, 0, 0, 0);
            this._originalImage.draw(img, matrix);

            this._currentBitmapData = new createjsUnsafe.BitmapData(null, stageW, stageH);
        }
        catch (e) {
            // security exception; tainted canvas (safari)
            $('#bucket').detach();
            // NOTE: this does not work, we still need the _currentBitmapData below
        }
        this._bitmap = new createjs.Bitmap(this._currentBitmapData.canvas);

        // make all clickable
        var hit = new createjs.Shape();
        hit.graphics.beginFill('#000').rect(0, 0, stageW, stageH);
        this._bitmap.hitArea = hit;
        this._bitmap.addEventListener("click", (evt) => {
            this.clickHandler(evt);
        });

        this._drawingCanvas = new createjs.Shape();

        // fill layer
        this._stage.addChild(this._bitmap);

        // drawings
        this._stage.addChild(this._drawingCanvas);

        // outlines
        var originalBitmap = new createjs.Bitmap(this._originalImage.canvas);
        this._stage.addChild(originalBitmap);

        var updateStage = () => {
            this._stage.update();
        };

        this._stage.update();

        // Layout colors
        var colors = $('#colors');
        this.alignVertically(colors, 50, stageH, 4);
        colors.show();
        colors.children().each((i, elem) => {
            let ctl = $(elem);

            let onSelect = () => {
                this._selectedColor = ctl.css('background-color');
                colors.children().removeClass('selected');
                ctl.addClass('selected');
            };

            ctl.click(() => {
                var s = ctl.data('sound');
                if (s) SoundManager.playSound(s);

                onSelect();
            });
            if (i == 0) {
                // select first color
                onSelect();
            }
        });
        // Move colors to right
        colors.css('left', (stageW - 20 - colors.find(':first').width()) + 'px');

        // Layout tools
        var tools = $('#tools');
        this.alignVertically(tools, 80, stageH, 25);
        tools.show();

        var setupTool = (tool, elem, sound) => {
            elem.click(() => {
                tools.children().removeClass('selected');
                elem.addClass('selected');
                this._selectedTool = tool;
                SoundManager.playSound(sound);
            });
        };

        setupTool(TOOL_BRUSH, tools.find('#brush'), 'kwast');
        setupTool(TOOL_PENCIL, tools.find('#pencil'), 'potlood');
        setupTool(TOOL_BUCKET, tools.find('#bucket'), 'emmer');
        $('#tools').children().first().click();

        ////
        $("#btn_undo").click(() => {
            if (this._undoData.length == 0)
                return;

            var undoSpec = this._undoData.pop();

            if (undoSpec.tool == TOOL_BUCKET) {
                this.floodFill(undoSpec.pos, undoSpec.color);
            } else {
                // use stored graphics
                this._drawingCanvas.graphics = undoSpec.graphics;
            }
            this.updateUndoButton();
            this._stage.update();
        });
        $('#btn_undo').hide();

        // load sounds
        Utils.initAudio();
        var sounds = ['donkerblauw', 'emmer', 'geel', 'kwast', 'lichtblauw', 'oranje', 'paars', 'potlood', 'rood', 'roze', 'groen',
            'emmer', 'kwast', 'potlood'];
        var manifest = [];
        for (var i = 0; i < sounds.length; i++) {
            manifest.push({src: AssetManager.getShared('sounds/' + sounds[i] + '.mp3'), id: sounds[i]});
        }
        var queue = new createjs.LoadQueue(false);
        queue.installPlugin(createjs.Sound);
        queue.loadManifest(manifest);
    }


    private updateUndoButton() {
        var btn = $('#btn_undo');
        if (this._undoData.length) {
            btn.show('slow');
        }
        else {
            btn.hide('slow');
        }
    }

    private alignVertically(container, btnHeight, totalHeight, spaceBetween) {
        // NOTE: div is still hidden because we're just now positioning it
        // we can't calculate height() or width() dynamically

        var btnsHeight = (btnHeight + spaceBetween) * container.children().length;
        var topOfBtns = (totalHeight / 2) - (btnsHeight / 2);
        container.children().each((i, btn) => {
            var top = topOfBtns + ((btnHeight + spaceBetween) * i);
            var btn = container.children().eq(i);
            btn.css('top', top + "px");
        });
    }

    // https://www.sitepoint.com/jquery-convert-rgb-hex-color/
    // but modified
    private rgb2hex(rgbString) {
        let rgb = rgbString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2);
    }

    private addUndo(spec) {
        if (this._undoData.length == MAX_UNDO) {
            // remove first
            this._undoData.shift();
        }
        this._undoData.push(spec);
        this.updateUndoButton();
    }

    private handleMouseDown(evt) {

        var stroke;
        var startDrawing = false;

        switch (this._selectedTool) {
            case TOOL_BRUSH:
                stroke = 15;
                this._drawingCanvas.graphics.setStrokeStyle(15, 'round', 'round');
                startDrawing = true;
                break;
            case TOOL_PENCIL:
                stroke = 2;
                this._drawingCanvas.graphics.setStrokeStyle(2, 'round', 'round');
                startDrawing = true;
                break;
        }

        if (startDrawing) {
            this._haveUndoForCurrentOperation = false;
            this._oldPt = new createjs.Point(this._stage.mouseX, this._stage.mouseY);
            this._oldMidPt = this._oldPt;
            this._mouseMoveListener = (evt) => {
                this.handleMouseMove(evt);
            }
            this._stage.addEventListener("stagemousemove", this._mouseMoveListener);
        }
    }

    private handleMouseMove(evt) {
        var midPt = new createjs.Point(this._oldPt.x + this._stage.mouseX >> 1, this._oldPt.y + this._stage.mouseY >> 1);

        // if we moved for the first time...
        if (!this._haveUndoForCurrentOperation) {
            this.addUndo({tool: this._selectedTool, graphics: this._drawingCanvas.graphics.clone()});
            this._haveUndoForCurrentOperation = true;
        }

        this._drawingCanvas.graphics
            .beginStroke(this._selectedColor)
            .moveTo(midPt.x, midPt.y)
            .curveTo(this._oldPt.x, this._oldPt.y, this._oldMidPt.x, this._oldMidPt.y);

        this._oldPt.x = this._stage.mouseX;
        this._oldPt.y = this._stage.mouseY;

        this._oldMidPt.x = midPt.x;
        this._oldMidPt.y = midPt.y;

        this._stage.update();
    }

    private handleMouseUp(evt) {
        this._stage.removeEventListener("stagemousemove", this._mouseMoveListener);
        this._mouseMoveListener = null;
    }

    private floodFill(bitmapPos, intColor) {
        console.time('fill');
        this._currentBitmapData.floodFill(bitmapPos.x, bitmapPos.y, intColor, this._originalImage);
        console.timeEnd('fill');
    }

    private clickHandler(evt) {
        if (this._selectedColor === undefined || this._selectedTool === undefined) {
            // should not be possible
            return;
        }

        switch (this._selectedTool) {
            case TOOL_BUCKET:

                var bitmapPos = this._bitmap.globalToLocal(evt.stageX, evt.stageY);
                console.log('click at ', evt.stageX, evt.stageY, ' bitmap pixel ',
                    bitmapPos.x, bitmapPos.y);

                // Add undo (flood fill again, with original color)
                console.time('undo');
                var currentColor = this._currentBitmapData.getPixel32(bitmapPos.x, bitmapPos.y);
                this.addUndo({tool: TOOL_BUCKET, pos: bitmapPos, color: currentColor});
                console.timeEnd('undo');

                // Convert selected color from "rgb(aaa,bbb,ccc)" string to 0xFFaabbcc int
                var intColor = parseInt("0xFF" + this.rgb2hex(this._selectedColor));
                this.floodFill(bitmapPos, intColor);

                break;
        }
        this._stage.update();
    }


}



// WEBPACK FOOTER //
// ./src/Kleurplaat.ts